import { BadServiceRequestException } from '../exceptions/bad-service-request-exception';
import { ForbiddenException } from '../exceptions/forbidden-exception';
import { NotFoundException } from '../exceptions/not-found-exception';
import { resolve } from 'aurelia-framework';
import { ApiService } from '../services/api-service';

export class ClientBase {
  protected apiService = resolve(ApiService);

  protected async transformResult<T>(_url: string, response: Response, process: (response: Response) => Promise<T>): Promise<T> {
    switch (response.status) {
      case 400: {
        const exception = await response.json() as { exception: string; error: string; title?: string };
        if (exception.exception === 'Dynamik.Shared.Core.Exceptions.BadServiceRequestException') {
          throw new BadServiceRequestException(exception.error, response.traceParent, response.status, exception, exception.title);
        } else {
          throw new BadServiceRequestException('An unexpected server error occurred.', response.traceParent, response.status, exception, exception.title);
        }
      }
      case 403: {
        throw new ForbiddenException(response.headers.get('hasacceptedenduserlicenseagreement') === 'false' ? 'You must accept the End User License Agreement before using this application.' : undefined);
      }
      case 404: {
        throw new NotFoundException();
      }
      case 500: {
        const exception = await response.json() as { exception: string; error: string };
        switch (exception.exception) {
          case 'MassTransit.UnhandledEventException':
            throw new BadServiceRequestException('The request cannot be handled during this entity state', response.traceParent, response.status, exception);
            case 'Dynamik.Shared.Core.Exceptions.NotFoundException':
              throw new NotFoundException(exception.error);
          default:
            throw new BadServiceRequestException('An unexpected server error occurred.', response.traceParent, response.status, exception);
        }
      }
    }
    return process(response);
  }
}
